import ContractSignatureInfo from 'components/ContractSignatureInfo';
import { bonatoCompany } from 'constants/company';
import { Date } from 'modules';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

interface PlaceSignatureProps {
  contract: GQL.IContract;
  form: GQL.IContractOnlineForm;
}

const PlaceSignature = ({ contract, form }: PlaceSignatureProps) => {
  return (
    <div className="mb-1">
      <Row>
        <Col sm={7}>
          V {contract?.spravaDluhu?.misto || 'Žiline'}, dňa <Date value={contract?.datum} />
          <br />
          <br />
          {bonatoCompany.name}
          <br />
          {contract?.consultant2 && (
            <>
              {contract?.consultant2.prijmeni} {contract?.consultant2.jmeno}
              <br />
            </>
          )}
          Oddlžovací poradca
          <br />
          na základe plnej moci
          <br />
        </Col>
        <Col sm={5}>{form && form.signIn !== null && <ContractSignatureInfo form={form} />}</Col>
      </Row>
    </div>
  );
};

export default PlaceSignature;
